// Creates a ViewState with selected contact for the ReadWriteRecipient
import type FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import type ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import { RecipientExpansionStatus } from 'owa-recipient-types/lib/types/RecipientExpansionStatus';
export default function getPersonaState(
    selectedPerson: FindRecipientPersonaType
): ReadWriteRecipientViewState {
    return {
        persona: selectedPerson,
        isExpanding: false,
        isEditing: false,
        isFadedOut: false,
        // Keeping consistent with ViewState in ImportFromDirectoryPanel.tsx
        isPendingResolution: selectedPerson?.EmailAddress?.MailboxType !== 'OneOff',
        expansionStatus: RecipientExpansionStatus.None,
        members: [],
        displayText: selectedPerson?.EmailAddress?.Name ?? '',
        isContextMenuOpen: false,
        isValid: true,
        isSelected: false,
    };
}
